import { render, staticRenderFns } from "./QuoteErrors.vue?vue&type=template&id=205a8a8a"
import script from "./QuoteErrors.vue?vue&type=script&lang=js"
export * from "./QuoteErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports